import { useShallow } from 'zustand/react/shallow';
import { createStoreHooks } from '../../../canvas/core';
import type { PageId } from '../../../document-canvas';
import type { PageSelectionSlice } from './slice';

const { useStore } = createStoreHooks<PageSelectionSlice>();

/** @public */
export const usePageSelection = () =>
  useStore(state => state.pageSelection.state.selection);

/** @public */
export const usePageSelectionActions = () =>
  useStore(useShallow(state => state.pageSelection.actions));

/** @public */
export const useIsPageSelected = (pageId: PageId) =>
  useStore(
    state =>
      state.pageSelection.state.selection?.pageIds.includes(pageId) ?? false
  );
